import axios from 'axios';

const API_BASE_URL = '/api'; // Usar proxy do Vite

// Configurar axios com interceptors
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  withCredentials: true, // Para cookies
  headers: {
    'Content-Type': 'application/json',
  }
});

// Interceptor para requisições
api.interceptors.request.use(
  (config) => {
    // Cookies são enviados automaticamente pelo navegador
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Variável para controlar se já está renovando
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

// Interceptor para respostas
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // Se erro 401 e não é rota de refresh ou login
    if (error.response?.status === 401 && !originalRequest._retry && 
        !originalRequest.url.includes('/refresh-token') && 
        !originalRequest.url.includes('/auth/login')) {
      
      if (isRefreshing) {
        // Já está renovando, adicionar à fila
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return api(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }
      
      originalRequest._retry = true;
      isRefreshing = true;
      
      try {
        // Tentar renovar token
        await axios.post(`${API_BASE_URL}/auth/refresh-token`, {}, {
          withCredentials: true
        });
        
        processQueue(null, true);
        return api(originalRequest);
        
      } catch (refreshError) {
        // Falha ao renovar
        processQueue(refreshError, null);
        localStorage.removeItem('user');
        localStorage.removeItem('sessionStartTime');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;
